

import { BaseEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumDocumentDownloadOption, EnumReportTabs } from '../enums';

export class DocumentsDownloadParams extends BaseEntity
{   
    public DateFrom: Date; 
    public DateUntil: Date; 
    public IsOpen: boolean; 
    public CompanyID: number; 
    public HasComplexFilter: boolean; 
    public ReportTab: EnumReportTabs;
    public DownloadOption: EnumDocumentDownloadOption;
}



